var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"long-comic-page"},[_c('LongComic',{attrs:{"images":_vm.post.acf.images,"content":_vm.post.content.rendered},on:{"close-popup":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }